const SDK_VERSION = '7.53.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
